// In src/services/auth.js

import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail // Import sendPasswordResetEmail
} from "firebase/auth";
import { auth } from "./firebase"; // Our initialized auth object from firebase.js

/**
 * Signs up a new user with an email and password.
 * @param {string} email - The user's email.
 * @param {string} password - The user's password.
 * @returns {Promise<UserCredential>}
 */
export const signUp = (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

/**
 * Signs in an existing user with an email and password.
 * @param {string} email - The user's email.
 * @param {string} password - The user's password.
 * @returns {Promise<UserCredential>}
 */
export const signIn = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

/**
 * Signs out the currently logged-in user.
 * @returns {Promise<void>}
 */
export const logOut = () => {
  return signOut(auth);
};

/**
 * Sends a password reset email to the specified email address.
 * @param {string} email - The user's email.
 * @returns {Promise<void>}
 */
export const resetPassword = (email) => {
  return sendPasswordResetEmail(auth, email);
};